<template>
    <div>
        <div class="container-fluid" id="invoice-preview-pdf" :style="{background: linear_gradient}">
            <div class="row">
                <div class="col text-center">
                    <md-button @click="goBack">Back</md-button>
                </div>

                <div class="col text-center">
                    <md-button @click="submitInvoice">Done</md-button>
                </div>
            </div>

            <img src="@/assets/images/placeholder-pdf.png">
        </div>
    </div>
</template>

<script>

    export default {
        name: 'InvoicePersonalization',
        data() {
            return {
                linear_gradient: 'linear-gradient(to bottom, #11998e, #16a58c)',
                isActive: false,
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1)
            },
            submitInvoice() {
                //call post invoice API
                this.$root.$emit('show-loading', true);

                this.axios({
                    method: 'post',
                    url: '/sales/invoices',
                    data: this.$store.state.invoice_obj,
                }).then(response => {
                    this.$root.$emit('show-loading', false);
                console.log('Submit invoice: ', response.data)
                    this.$router.push({name: 'invoice'})
                }).catch(error => {
                    this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
                })
            }
        },
        mounted() {
            console.log('Invoice object: ', this.$store.state.invoice_obj)
        }
    }
</script>

<style lang="scss">
    $screen-sm-min: 375px;

    @mixin sm {
        @media (min-width: #{$screen-sm-min}) {
            @content;
        }
    }

    #invoice-preview-pdf {
        position: relative;
        height: calc(100vh);
        transition: background-color 0.2s ease-in-out;
        // background: linear-gradient(to bottom, #11998e, #16a58c);

        button {
            color: white;
        }

        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding-bottom: 15px;
            width: 75%;
        }
    }

</style>
